import { LanguageType } from '../types';

export const changeLanguageInUrl = (lang: LanguageType) => {
  const { pathname } = window.location;
  let newPath;
  const queryParams = new URLSearchParams(window.location.search).toString();
  const [, , ...rest] = pathname.split('/');
  newPath = `/${lang}${rest.length ? `/${rest.join('/')}` : ''}`;
  newPath += queryParams ? `?${queryParams}` : '';
  window.location = newPath;
};
